import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'binsta-auth',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {

}
